import { footerSchema } from '@ecomm/footer-data'
import { type TypeOf, z } from '@simplisafe/ewok'

export const layoutSchema = z.object({
  footer: footerSchema,
  promoBannerStyle: z.string()
})

export type LayoutFragment = TypeOf<typeof layoutSchema>
